module.exports = __webpack_public_path__ + "8681cb0fc391cd58cb385f0777d0103c.svg";